var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCircleOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Add circle outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9 10.5H18.1V18.1H10.5V21.9H18.1V29.5H21.9V21.9H29.5V18.1H21.9V10.5ZM20 1C9.512 1 1 9.512 1 20C1 30.488 9.512 39 20 39C30.488 39 39 30.488 39 20C39 9.512 30.488 1 20 1ZM20 35.2C11.621 35.2 4.8 28.379 4.8 20C4.8 11.621 11.621 4.8 20 4.8C28.379 4.8 35.2 11.621 35.2 20C35.2 28.379 28.379 35.2 20 35.2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleOutlined);
export default __webpack_public_path__ + "static/media/AddCircleOutlined.cc13f09b0ebaabc0ae43645371054561.svg";
export { ForwardRef as ReactComponent };